import React, { FunctionComponent } from "react";

import "./CartDetailedSectionHeader.scss";

type Props = {
  children: React.ReactNode;
};

const CartDetailedSectionHeaderComponent: FunctionComponent<Props> = ({
  children,
}) => <h3 className="cart-detail-section-header">{children}</h3>;

export default CartDetailedSectionHeaderComponent;
